var map = {
	"./canva.png": 566,
	"./chatgpt.png": 374,
	"./chegg.png": 939,
	"./gptzero.png": 646,
	"./grammarly.png": 349,
	"./instagram.png": 183,
	"./logos": 723,
	"./logos.js": 723,
	"./quizlet.png": 353,
	"./snapicon.png": 244,
	"./sparknotes.png": 173,
	"./wolframalpha.png": 487
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 379;